import { useState } from 'react';
import type { IProduct, Nullable, ProviderProduct } from '@recargas-dominicanas/core/types';
import { ProviderProductApi } from '@recargas-dominicanas/core/api';
import { TextField } from '@recargas-dominicanas/core/components';
import { ProductSelect } from '../../../../components/product-select/product-select.component';
import { Modal } from '../../../../components/modal/modal.component';
import { ProviderStore } from '../../../../store/providerStore';
import { useForm } from '@recargas-dominicanas/core/hooks';
import { style } from './edit-product-modal.module.css';

interface Props {
  open: boolean;
  providerId: number;
  providerProduct: ProviderProduct;
  onClose: () => void;
}

export function EditProductModal(props: Props) {

  const {
    open,
    providerId,
    providerProduct,
    onClose
  } = props;

  const [error, setError] = useState<string>();
  
  const form = useForm({
    product: { value: providerProduct.product as Nullable<IProduct> },
    profit: providerProduct.profit.toString(),
    key: providerProduct.key
  }, [open]);

  async function handleSave() {

    if (!form.validate()) return;

    setError(undefined);

    try {

      await ProviderProductApi.update(providerProduct.id, {
        key: form.key.value,
        profit: parseFloat(form.profit.value),
        productId: form.product.value!.id,
      });

      await ProviderStore.fetchProducts(providerId);

      handleClose();

    } catch {

      setError('Error actualizando producto');
    }
  }

  function handleClose() {
    form.clear();
    setError(undefined);
    onClose();
  }

  return (
    <Modal
      open={open}
      title='Editar producto'
      style={style.modal}
      secondaryButton='Guardar'
      error={error}
      onClose={handleClose}
      onSecondaryClick={handleSave}>
      <ProductSelect
        className={style.select}
        label='Producto'
        placeholder='Seleccionar producto'
        value={form.product.value}
        error={form.product.error}
        onChange={form.product.onChange}/>
      <TextField 
        style={style.textField}
        label='Beneficio'
        type='number'
        value={form.profit.value}
        error={form.profit.error}
        onChange={form.profit.onChange}
        onBlur={form.profit.onBlur}/>
      <TextField 
        style={style.textField}
        label='Clave'
        value={form.key.value}
        error={form.key.error}
        onChange={form.key.onChange}
        onBlur={form.key.onBlur}
        onEnter={handleSave}/>
    </Modal>
  );
}
